import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const InboundSupplyOrderCheckQtyRBAC = {
  pageID: '9bd395c08c0dbedb7060956a2562b1a5',
  elementID: {
    UpdateCheckQty: '5654474efb6efda57f65c3e085ab8ba5',
  },
} as const

export const useRBACInboundSupplyOrderCheckQtyPage = createUseRBAC(
  InboundSupplyOrderCheckQtyRBAC.elementID,
)
export type UseRBACInboundSupplyOrderCheckQtyPageType = ReturnType<
  typeof useRBACInboundSupplyOrderCheckQtyPage
>
